import { render, staticRenderFns } from "./CustomFileInput.vue?vue&type=template&id=05f5f453&scoped=true&"
import script from "./CustomFileInput.vue?vue&type=script&lang=js&"
export * from "./CustomFileInput.vue?vue&type=script&lang=js&"
import style0 from "./CustomFileInput.vue?vue&type=style&index=0&id=05f5f453&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f5f453",
  null
  
)

export default component.exports